import mapKnownValues from "@/utils/mapKnownValues";
import { EntityType } from "@/classes/entity";
import { ItemStatusType } from "@/classes/itemStatusType";

export type PricingResponse = {
  id: string;
  isFree: boolean;
  entity: EntityType;
  entityId: string;
  policy: PricingPolicy;
  rate: number;
  penalty: number;
  penaltyDelayMinutes: number;
  startDelayMinutes: number;
  inactivatedAt: string; // date
  createdAt: string;
  createdBy: string;
  itemStatus: ItemStatusType;
  jsonData: null | undefined;
  penaltyUnit: PenaltyUnit;
};

export type PricingAPIResponse = {
  activePolicy: PricingResponse | null;
  inheritedFrom: PricingResponse | null;
};

export enum PricingPolicy {
  kwh = "KWH",
  minute = "MINUTE",
  hour = "HOUR",
  tou = "TOU"
}

export enum PenaltyUnit {
  minute = "MINUTE",
  hour = "HOUR"
}

export default class Pricing {
  inheritedFromDetails: PricingResponse | undefined = undefined;
  activePolicyId: string | undefined = undefined;
  id = "";
  isFree = false;
  entity: EntityType = EntityType.STATION;
  entityId = "";
  policy: PricingPolicy = PricingPolicy.kwh;
  rate = 0; // Based on policy. kwh or by minute (which is "time" for now)
  penalty: number | null = null;
  startDelayMinutes = 0;
  penaltyDelayMinutes: number | null = null;
  inactivatedAt: null | Date = null; // Date
  createdAt = new Date();
  createdBy = "";
  itemStatus = ItemStatusType.DISABLED;
  inheritPricing = false;
  jsonData: string | null = null;
  penaltyUnit = PenaltyUnit.hour;

  constructor(params: Partial<Pricing> = {}) {
    mapKnownValues(this, params);
  }

  get enums() {
    return {
      policy: PricingPolicy
    };
  }

  get possibleInheritFrom() {
    switch (this.entity) {
      case EntityType.STATION:
        return "Property";
      case EntityType.PROPERTY:
        return "Organization";
    }
    return "";
  }

  get entityName() {
    switch (this.entity) {
      case EntityType.STATION:
        return "Station";
      case EntityType.CLUSTER:
        return "Cluster";
      case EntityType.ORGANIZATION:
        return "Organization";
      case EntityType.PANEL:
        return "Panel";
    }
    return "";
  }
}
